"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Header_1 = require("./Header");
var Footer_1 = require("./Footer");
exports.default = (function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "container-fluid", style: { backgroundColor: "white", minHeight: "100%", position: 'relative' } },
        React.createElement("div", { className: "row" },
            /*React.createElement("div", { className: "col-sm-1" }),*/
            React.createElement("div", { className: "col-sm-12", style: { backgroundColor: "white" } },
                React.createElement(Header_1.default, null)),
            /*React.createElement("div", { className: "col-sm-1" })*/),
        React.createElement("div", { className: "row flexMiddleContainer" },
            React.createElement("div", { className: "col-sm-1" }),
            React.createElement("div", { className: "col-sm-10", style: { backgroundColor: "white" } },
                React.createElement(reactstrap_1.Container, null, props.children)),
            React.createElement("div", { className: "col-sm-1" })),
        React.createElement("div", { className: "row", style: { position: 'relative', bottom: '0', minHeight: '125px' } },
            /*React.createElement("div", { className: "col-sm-1" }),*/
            React.createElement("div", { className: "col-sm-12", style: { backgroundColor: "#505759" } },
                /*React.createElement("hr", null),*/
                React.createElement(Footer_1.default, null)),
           /* React.createElement("div", { className: "col-sm-1" })*/)))); });
//# sourceMappingURL=Layout.js.map